import { FragmentDefiner } from "../../../GlobalHooks/useReadFragment";

import { FRAGMENT_PROPERTY_COVER_TAG } from "./PropertyCoverTag/hook";
import { PropComponentMode } from "../../../Components/Property/PropertyInterfaces";
import { FileType } from "shared-components";

export const FRAGMENT_PROPERTY_COVER = new FragmentDefiner(
	"Property",
	`
    id
    img
    image_count
    youtube
    images {
        image
    }project{
        id
        images{
            image
            tag
        }
    }
`
).uses(FRAGMENT_PROPERTY_COVER_TAG);

export interface ImageProps {
	images: Image[];
	img: string;
	isProject?: boolean;
	isEspecial?: Boolean;
	id: string;
	mode: PropComponentMode;
	loading?: boolean;
	tour3d: string;
	files: FileType[];
	latitude: number;
	isDisabledProperty?: boolean;
	onTabClick: (tab: any) => void;
}

export const usePropertyCover = (
	mode: PropComponentMode,
	images: Image[],
	isProject: boolean = false,
	img: string = ""
) => {

	return {
		data: formatImgs(isProject, mode, images, img),
	};
};

const formatImgs = (isProject, mode, images, img) => {
	let data = null;
	if ((isProject && mode == "auto") || mode == "project") {
		let imgs = images?.filter(image => image.tag != "construction_advances");
		data = {
			img: imgs[0]?.image,
			images: imgs,
		};
	} else {
		data ={
			img: img && img.length > 0 ? img : images[0]?.image,
			images: images,
		};
	}
	return data
}
